import React from 'react'
import Calendar from 'react-calendar'
import { Form, FormRow, Select } from '../common/Form'
import moment from 'moment'
//import Autosuggest from 'react-autosuggest'

class AddEvenimentForm extends React.Component {
    constructor(props) {
        super(props)

        this.highlight = this.highlight.bind(this)
    }

    get mapArtistsToSelect() {
        let list = []

        this.props.artists.map(artist => {
            list.push({
                value: artist.id,
                label: artist.name
            })

            return null
        })

        return list
    }

    get mapPlacesToSelect() {
        let list = []

        this.props.places.map(place => {
            list.push({
                value: place.id,
                label: place.name
            })

            return null
        })

        return list
    }

    highlight({ date, view }) {
        return view === 'month' && this.props.eveniments.find(item => {
            return moment(item.startdate).isSame(date.toISOString()) && item.artistId === this.props.artistId
        }) ? 'is-active' : null
    }

    render() {
        return (
            <Form>
                <FormRow>
                    <Select
                        placeholder="Alege artist"
                        list={this.mapArtistsToSelect}
                        value={this.props.artistId}
                        onChange={this.props.onChangeArtist} />
                </FormRow>

                <FormRow>
                    <Select
                        placeholder="Alege localitate"
                        list={this.mapPlacesToSelect}
                        value={this.props.placeId}
                        onChange={this.props.onChangePlace} />
                </FormRow>

                <FormRow>
                    <Calendar
                        value={new Date(this.props.startdate)}
                        tileClassName={this.highlight}
                        onChange={this.props.onDatePick} />
                </FormRow>
            </Form>
        )
    }
}

export default AddEvenimentForm


// WEBPACK FOOTER //
// ./src/components/eveniments/AddEvenimentForm.js